/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Import_SourceInputs */

const cs_import_source = /** @type {(inputs: Import_SourceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zdroj dat`)
};

const en_import_source = /** @type {(inputs: Import_SourceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Data source`)
};

/**
* | output |
* | --- |
* | "Data source" |
*
* @param {Import_SourceInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const import_source = /** @type {((inputs?: Import_SourceInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Import_SourceInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_import_source(inputs)
	return cs_import_source(inputs)
});